export default __webpack_public_path__ + "static/media/shop-location.96fad22a.svg";